module.exports = __webpack_public_path__ + "img/Overlay (4).ea3ba456.png";